import type { PageFlowState } from '../types';

const FLOW_RUNTIME_STORAGE_PREFIX = 'eco3d:flow-runtime:v1:';

function getFlowRuntimeStorageKey(flowIds: string[]) {
  return `${FLOW_RUNTIME_STORAGE_PREFIX}${flowIds.slice().sort().join('|')}`;
}

function clearPersistedFlowRuntimeState(flowIds: string[]) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(getFlowRuntimeStorageKey(flowIds));
  } catch {
    // Ignore localStorage failures and keep runtime in-memory.
  }
}

export function loadPersistedFlowRuntimeState(flowIds: string[]): PageFlowState | null {
  if (typeof window === 'undefined' || flowIds.length === 0) return null;

  clearPersistedFlowRuntimeState(flowIds);
  return null;
}

export function savePersistedFlowRuntimeState(flowState: PageFlowState, flowIds: string[]) {
  if (typeof window === 'undefined' || flowIds.length === 0) return;

  clearPersistedFlowRuntimeState(flowIds);
}
